import { ActivityDataSource } from '@cozero/models'

export function createActivityDataSourceName(activityDataSource: ActivityDataSource): string {
  let name = activityDataSource?.name
  if (activityDataSource.parent) {
    name = `${activityDataSource.parent.name} > ${name}`
  }
  return name
}
